import type { ReactNode } from "react";

interface BodyProps {
  children: Readonly<ReactNode>;
}

export default function Body({ children }: BodyProps) {
  return (
    <div className="flex lg:max-w-lg xl:max-w-xl grow flex-col justify-center gap-2 lg:pe-8">
      {children}
    </div>
  );
}
